import(/* webpackMode: "eager", webpackExports: ["Wrapper"] */ "/workspace/src/components/moleculer/wrapper.tsx");
